import React from 'react';
import { Popover } from 'material-ui';
import styled from 'styled-components';
import Copy from 'material-ui/svg-icons/content/content-copy';

export default function RefNosTooltip({
    open, elementTarget, close, refNos, 
}) {
    return (
        <Popover
            open={open}
            anchorEl={elementTarget}
            onRequestClose={close}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
            <StyledBody>
                {
                    refNos.map(refNo => (
                        <StyledBodyItem key={refNo}>
                            {refNo}
                            <Copy 
                                style={{ height: '16px', width: '16px', cursor: 'pointer' }} 
                                onClick={() => navigator.clipboard.writeText(refNo)}
                            />
                        </StyledBodyItem>
                    ))
                }
            </StyledBody>
        </Popover>
    );
}

const StyledBody = styled.div`
    display: flex;
    gap: 10px;
    padding: 10px;
    flex-direction: column;
`;

const StyledBodyItem = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
    font-size: 13px;
`;



// WEBPACK FOOTER //
// ./app/components/Letters/common/RefNosTooltip.jsx